import { Directive, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router'
@Directive({
    selector: "[hybridHref]",
})
export class HybridHref {
    private AZURE_CM_REGEX = /\.azurewebsites\.net$/i;
    private FILE_REGEX = /\.(pdf|docx?|xlsx?|pptx?|zip|rar|csv)$/i;

    constructor(public router: Router, private activateRoute: ActivatedRoute) {}

    // @HostListener('click', ['$event']) onClick($event:any) {
    //   if ($event.currentTarget
    //       && !(new RegExp("#$").test($event.currentTarget?.href))
    //       && !(new RegExp("^mailto:").test($event.currentTarget?.href))
    //       && !$event.currentTarget.classList.contains("no-link")
    //       && $event.currentTarget?.target != '_blank') {
    //     $event.preventDefault();

    //     if($event.currentTarget.hostname != window.location.hostname){
    //       window.open($event.currentTarget.href, "_blank");
    //     }
    //     else{
    //       if (document.body?.style?.overflow === 'hidden') {
    //         document.body.style.overflow = '';
    //       }
    //       this.router.navigateByUrl($event.currentTarget.pathname + ($event?.currentTarget?.hash && !($event?.currentTarget?.hash as string).includes('=') ? $event?.currentTarget?.hash:'') );
    //     }
    //   }
    // }

    @HostListener("click", ["$event"])
    onClick($event: any) {
        const el = $event.currentTarget as HTMLAnchorElement;
        if (!el || !el.href) return;

        if (el.target === "_blank" || el.classList.contains("no-link") || el.href.endsWith("#") || el.href.startsWith("mailto:")) {
            return;
        }

        const isFile = this.FILE_REGEX.test(el.pathname);
        const isAzureCm = this.AZURE_CM_REGEX.test(el.hostname);

        if (isFile) {
            $event.preventDefault();
            let fileUrl = el.href;

            // coming from Sitecore CM (azurewebsites) replace with public domain
            if (isAzureCm) {
                fileUrl = window.location.origin + el.pathname;
            }

            window.open(fileUrl, "_blank");
            return;
        }

        $event.preventDefault();

        // external links
        if (el.hostname !== window.location.hostname) {
            window.open(el.href, "_blank");
            return;
        }

        // navigation
        if (document.body?.style?.overflow === "hidden") {
            document.body.style.overflow = "";
        }
        
        this.activateRoute.queryParams.subscribe((params) => {
          const queryParams = { ...params };

          const path = $event?.currentTarget?.pathname;
          const hash = $event?.currentTarget?.hash && !$event?.currentTarget?.hash.includes('=') ? $event?.currentTarget?.hash : '';

          if(queryParams?.branchCode){
            this.router.navigate([path + hash], { queryParams });
          }else{
            if ($event?.currentTarget?.href?.includes('?partnertype')) {
              const href = $event.currentTarget.href;
              const urlObj = new URL(href, window.location.origin);
              const queryParams: Record<string, string> = {};
              urlObj.searchParams.forEach((value, key) => {
                queryParams[key] = value;
              });

              this.router.navigate([path + hash], { queryParams });
            }else{
              this.router.navigateByUrl($event.currentTarget.pathname  + ($event?.currentTarget?.hash && !($event?.currentTarget?.hash as string).includes('=') ? $event?.currentTarget?.hash:''));
            }
          }
        });

        // this.router.navigateByUrl($event.currentTarget.pathname 
        //   + ($event?.currentTarget?.hash && !($event?.currentTarget?.hash as string).includes('=') ? $event?.currentTarget?.hash:'') 
        //   + param?.branchCode ? param : '' );
    }
  }
  